//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultHeaderLoader from "./generic-modal-loaders/default-header-loader.vue";
import DefaultBodyLoader from "./generic-modal-loaders/default-body-loader.vue";
import DefaultFooterLoader from "./generic-modal-loaders/default-footer-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GenericModal",
  components: {
    DefaultHeaderLoader,
    DefaultBodyLoader,
    DefaultFooterLoader
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    backdrop: {
      type: [Boolean, String],
      default: "static"
    },
    headerClass: {
      type: String,
      default: "pt-4 pb-0 px-4 b-0"
    },
    headerCloseButton: {
      type: Boolean,
      default: false
    },
    bodyClass: {
      type: String,
      default: "px-4"
    },
    footerClass: {
      type: String,
      default: "px-4"
    },
    footerCloseButton: {
      type: Boolean,
      default: true
    },
    footerCloseButtonText: {
      type: String,
      default: ""
    },
    modalDialogScrollable: {
      type: Boolean,
      default: true
    },
    modalDialogCentered: {
      type: Boolean,
      default: true
    },
    modalDialogSize: {
      type: String,
      default: ""
    },
    modalHeader: {
      type: Boolean,
      default: true
    },
    modalFooter: {
      type: Boolean,
      default: true
    },
    loadersDisabled: {
      type: Boolean,
      default: false
    },
    modalClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    noEnforceFocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalVisible: false,
      modalData: {},
      loading: true
    };
  },
  computed: {
    computedFooterCloseButtonText() {
      if (!this.footerCloseButtonText) return this.$t("global.words.close");
      return this.footerCloseButtonText;
    }
  },
  destroyed() {
    this.$root.$off("modal-bind-data", this._handleBindData);
  },
  mounted() {
    this.$root.$on("modal-bind-data", this._handleBindData);
    // lets bind some utils to the component using GenericModal
    this.$parent.$showModal = this.show;
    this.$parent.$hideModal = this.hide;
  },
  methods: {
    /* "public" methods */
    show() {
      this.modalVisible = true;
    },
    hide() {
      this.modalVisible = false;
    },
    toggle() {
      this.modalVisible = !this.modalVisible;
    },
    /* "private" methods */
    _handleModalShow(...props) {
      // Prevent opening modals that are inactive
      // A patch for components inside router-view with keep-alive
      if (this._inactive) {
        props[0].preventDefault();
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
      });
      this._triggerEvent("show", ...props);
    },
    _handleModalShown(...props) {
      this.modalVisible = true;
      this.$nextTick(() => {
        this.loading = false;
      });
      this._triggerEvent("shown", props);
    },
    _handleModalHide(...props) {
      this._triggerEvent("hide", props);
    },
    _handleModalHidden(...props) {
      this.modalVisible = false;
      this._triggerEvent("hidden", props);
    },
    _triggerEvent(eventName, ...data) {
      this.$emit(eventName, ...data);
    },
    _handleBindData(modalTarget, data) {
      if (this.id === modalTarget) {
        this.modalData = data;
      }
    }
  }
});